import React, { Component } from 'react'

export class Bar extends Component {
  render() {
    const bgColor = {
        color: this.props.color
    }
    return (
        <div style={bgColor} className="categoriesBar">{this.props.name}</div>
    )
  }
}

export default Bar
